import pkg from '../../package.json'

export const getDefaultConfig = (configOverrides) => {
  const env = configOverrides.NODE_ENV ?? 'development'
  const configEnv = configOverrides.NODE_CONFIG_ENV ?? 'development'
  const dev = env === 'development'
  const devConfig = configEnv === 'development'
  const prod = ['production'].includes(configEnv)
  // const https = Boolean(publicRuntimeConfig.NODE_HTTPS) || false;

  const isDebugPanelEnabled = ['development', 'testing'].includes(configEnv)

  const appLocale = configOverrides.NODE_LOCALE || 'ru-RU'

  return {
    env,
    configEnv,
    dev,
    devConfig,
    prod,
    isDebugPanelEnabled,

    devtools: false,
    ssr: false,

    ignoreWebviewGuard: false,

    locale: {
      default: 'ru-RU',
      active: appLocale,
    },

    proxy: {
      options: [
        {
          target: configOverrides.ELASTIC_APM_SERVER_URL || '/',
          changeOrigin: true,
          pathFilter: ['/front/api/apm/events'],
          pathRewrite: {
            '^/front/api/apm/events': '/intake/v2/rum/events',
          },
        },
        {
          target: configOverrides.NODE_API_FRONTBFF_URL || '/',
          changeOrigin: true,
          pathFilter: ['/front/api/'],
          pathRewrite: {
            '^/front/api/': '',
          },
        },
        {
          target: configOverrides.NODE_API_PRIZE_URL || '/',
          changeOrigin: true,
          pathFilter: ['/web/api/v1/prizes/'],
          pathRewrite: {
            '^/web/': '',
          },
        },
        {
          target: configOverrides.NODE_API_WEBBFF_URL || '/',
          changeOrigin: true,
          pathFilter: ['/web/'],
          pathRewrite: {
            '^/web/': '',
          },
        },
      ],
    },

    apm: {
      active: true,
      serviceVersion: pkg.version,
      environment: env,
      serviceName: 'Plaid_Web_Frontend_Client',
      serverUrlPrefix: '/front/api/apm/events',
      monitorLongtasks: true,
      sendCredentials: true,
    },

    gtm: {
      autoInit: false,
      enabled: true,
      debug: false,
      id: 'GTM-K9LNN8Q',
    },

    dayjs: {
      locales: ['ru', 'be', 'kk', 'ar', 'en'],
      defaultLocale: 'ru',
      defaultTimeZone: 'Europe/Moscow',
      plugins: [
        'advancedFormat',
        'utc',
        'timezone',
        'relativeTime',
        'customParseFormat',
        'localeData',
        'localizedFormat',
        'weekday',
        'toObject',
        'objectSupport',
        'isBetween',
      ],
    },

    enabledCart: true,
    enabledListingAppearing: false,
    storybook: {
      port: 4000,
    },
  }
}
